import { render, staticRenderFns } from "./SynchronizeShopifyModule.vue?vue&type=template&id=5f850aae&scoped=true"
import script from "./SynchronizeShopifyModule.vue?vue&type=script&lang=js"
export * from "./SynchronizeShopifyModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f850aae",
  null
  
)

export default component.exports